<template>
  <div class="office-object-internals">
    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events-->
    <div
      v-if="objectInternalPermission"
      class="text-primary d-inline-block clickable-element"
      data-ident="showObjectInternals"
      @click.prevent="showObjectInternals = !showObjectInternals"
    >
      <i class="icon"><icon-info-circle-alternative-two /></i>
      <object-number-agency
        :object-number="objectNumber"
        :object-data-internal="objectDataInternal"
      />
    </div>
    <ul v-if="objectInternalPermission && showObjectInternals">
      <li
        v-for="(objectInternal, objectInternalName) in objectDataInternal"
        :key="objectInternalName"
      >
        <template v-if="objectInternal.value">
          {{ $t('object:internals.' + objectInternalName) }}:
          <a
            v-if="objectInternal.link"
            class="text-primary"
            :href="objectInternal.link"
          >
            {{ objectInternal.value }}
          </a>
          <span v-else>
            {{ objectInternal.value }}
          </span>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import UserApi from 'mixins/UserApi';
import AnchorRouterPush from 'mixins/AnchorRouterPush';
import IconInfoCircleAlternativeTwo from 'ICON:IconInfoCircleAlternativeTwo';
import ObjectNumberAgency from 'components/ObjectNumberAgency.vue';
import { fromISODateTimeString } from '@/utils/DateHelper';

export default {
  name: 'ObjectInternals',
  components: {
    IconInfoCircleAlternativeTwo,
    ObjectNumberAgency,
  },
  mixins: [
    AnchorRouterPush,
    UserApi,
  ],
  props: {
    objectNumber: {
      required: true,
      type: [Number, String],
    },
  },
  data() {
    return {
      showObjectInternals: false,
    };
  },
  computed: {
    userDataReady() {
      return this.$store.getters.userDataStatus;
    },
    objectDataInternal() {
      // get internal data from store. ajax for internal object data is done in parent component
      const objectDataInternalVuex = this.$store.getters.getObjectInternal(this.objectNumber);
      if (objectDataInternalVuex?.lastUpdated) {
        objectDataInternalVuex.lastUpdated.value = fromISODateTimeString(objectDataInternalVuex.lastUpdated.value);
      }
      return objectDataInternalVuex;
    },
    objectInternalPermission() {
      let permissionType = false;
      if (this.UserApi_checkPermission('objectInternal.show')) {
        permissionType = 'objectInternal.show';
      }
      if (this.UserApi_checkPermission('objectInternal.reduced.show')) {
        permissionType = 'objectInternal.reduced.show';
      }
      if (this.UserApi_checkPermission('objectInternal.minimal.show')) {
        permissionType = 'objectInternal.minimal.show';
      }
      return permissionType;
    },
  },
  watch: {
    objectInternalPermission: {
      handler: 'getObjectInternal',
    },
  },
  methods: {
    getObjectInternal() {
      if (this.userDataReady && this.objectInternalPermission) {
        this.$store.dispatch('GET_OBJECT_INTERNAL', { objectNumbers: [this.objectNumber] }).catch(() => {});
      }
      return Promise.resolve();
    },
  },
};
</script>

<style lang="scss" scoped>
.office-object-internals {
  font-size: .9em;
  line-height: 1.2em;
  margin: .5em 0;
  padding: 0;
  .text-primary {
    cursor: pointer;
  }
  ul {
    padding-inline-start: unset;
    background: #f5f5f5;
    padding: 0.5em;
    border-radius: 10px;
    li {
      list-style: none;
    }
  }
}
</style>
